/* eslint-disable no-console */
import { API } from 'aws-amplify';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}
export function CreateRecognition(body:any, query:any)
{
	return API.post('taskManagement', `/recognition${query}`, { body });
}
export function UpdateRecognition(query:any, body:any)
{
	return API.put('taskManagement', `/recognition${query}`, { body });
}
export function getEmployeeRecognition(query:any)
{
	return API.get('taskManagement', `/getEmployee${query}`, init);
}
export function getCongratulationPopUp(query:any)
{
	return API.get('taskManagement', `/empRecognition${query}`, init);
}
export function deleteRecognise(query): Promise<any>
{
	return API.del('taskManagement', `/recognition/${query}`, init);
}
export function getEvents(query): Promise<any>
{
	return API.get('taskManagement', `/getEvents${query}`, init);
}
export function getEventComments(queryStringParameters:any)
{
	return API.get('taskManagement', '/recognitionComment', { queryStringParameters });
}
export function createEventComments(body:any, queryStringParameters:any):Promise<any>
{
	return API.post('taskManagement', '/recognitionComment', { body, queryStringParameters });
}
export function closeCongratulationPopUp(query:any, body:any)
{
	return API.put('taskManagement', `/recognition${query}`, { body });
}
export function deleteEventComment(path:any, queryStringParameters:any):Promise<any>
{
	return API.del('taskManagement', `/recognitionComment/${path}`, { queryStringParameters });
}
export function updateEventComment(body:any, queryStringParameters:any):Promise<any>
{
	return API.put('taskManagement', '/recognitionComment', { body, queryStringParameters });
}
export function getEventLikes(query:any):Promise<any>
{
	return API.get('taskManagement', `/recognitionLike${query}`, init);
}
export function recognizationTemplateDownload(query:any):Promise<any>
{
	return API.get('contentManagement', `/recogDownload${query}`, init);
}